/**
 * Created by DejanK on 3/17/2017.
 */
import angular from 'angular'
import rbHomeFooter from './rb-home-footer/rb-home-footer.cmp'

export default angular.module('rb.core.ui.footers', [])
    .component('rbHomeFooter', rbHomeFooter)
